import React from 'react';

interface MarkerProps {
  lat: number;
  lng: number;
  pro: any;

  onPress: () => void;
}
const ProMarker: React.FC<MarkerProps> = (props) => {
  const pro = props.pro          
  const text = pro.name + ' - ' + pro.address + ', ' + pro.city + ' ' + pro.postal_code
  return (
    <div className="pro-marker">
      <div className="logo"><img src={require('../../../images/logo.png')} /></div>
      <div className="marker-content">
        <div>{text}</div>
        <div className="text-primary" onClick={props.onPress}>Accéder au compte</div>
      </div>
    </div>
  )
};

export default ProMarker